<div *ngIf="!isInformationBarClose && ((hasFeature$ | async)('VISITOR'))"
  class="notification-message-container  w-p-100 m-b-10 flex flex-row justify-between items-center"
     >
  <div>
    <span>Note:</span> <span>You have been assigned to this Task and you can view the basic details below, including the current Task
    Status, Title/Description and Due Date (if applicable). Please make sure to review any Attachments and Comments.</span>
  </div>
  <button (click)="close()"
          mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>
<button
  mat-button
  class="light-background-button w-p-100 m-b-10"
  *ngIf="!isDefaultMainView"
  data-copilot="task-body-btn-close"
  (click)="onCloseClicked()"><i class="fas fa-times"></i>close</button>
<ng-template #dynamicComponent></ng-template>
